// src/Result.tsx
import React from 'react';
import { ResultProps } from './types';

const Result: React.FC<ResultProps> = ({ score, totalQuestions }) => {
  return (
    <div className="result-section">
      <h2>Quiz Completed!</h2>
      <p>
        You scored {score} out of {totalQuestions}.
      </p>
      <button onClick={() => window.location.reload()}>Restart Quiz</button>
    </div>
  );
};

export default Result;
